// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"YP-z","carouselContainer":"ZP-z"};